var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg173(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3188_4182)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.1999C0 14.9877 0.0648351 14.7842 0.180242 14.6342C0.295649 14.4842 0.452174 14.3999 0.615385 14.3999H15.3846C15.5478 14.3999 15.7044 14.4842 15.8198 14.6342C15.9352 14.7842 16 14.9877 16 15.1999C16 15.4121 15.9352 15.6156 15.8198 15.7656C15.7044 15.9156 15.5478 15.9999 15.3846 15.9999H0.615385C0.452174 15.9999 0.295649 15.9156 0.180242 15.7656C0.0648351 15.6156 0 15.4121 0 15.1999Z",
    fill: "#DB2A12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26676 7.2002H2.13343C1.83888 7.2002 1.6001 7.48162 1.6001 7.82877V15.3716C1.6001 15.7188 1.83888 16.0002 2.13343 16.0002H4.26676C4.56132 16.0002 4.8001 15.7188 4.8001 15.3716V7.82877C4.8001 7.48162 4.56132 7.2002 4.26676 7.2002Z",
    fill: "#DB2A12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06657 0H6.93324C6.63868 0 6.3999 0.275517 6.3999 0.615385V15.3846C6.3999 15.7245 6.63868 16 6.93324 16H9.06657C9.36112 16 9.5999 15.7245 9.5999 15.3846V0.615385C9.5999 0.275517 9.36112 0 9.06657 0Z",
    fill: "#DB2A12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8669 4H11.7335C11.439 4 11.2002 4.26863 11.2002 4.6V15.4C11.2002 15.7314 11.439 16 11.7335 16H13.8669C14.1614 16 14.4002 15.7314 14.4002 15.4V4.6C14.4002 4.26863 14.1614 4 13.8669 4Z",
    fill: "#DB2A12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3188_4182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg173);
export default __webpack_public_path__ + "static/media/svg173.e31cdbcd58b3bb3ceb75d1fdb9fd62ea.svg";
export { ForwardRef as ReactComponent };